import React from 'react'
import { clearEndpoint, getEndpoint, putEndpoint } from "../../../../actions";
import { ENDPOINT_PERMISSION_TYPE } from "../../../../config/constants";
import { ENDPOINT_PATH } from "../../../../config/paths";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import Content from "../../../layout/Content";
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes, matchPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { useLayoutEffect } from 'react';
import EndpointForm from './EndpointForm';
import Immutable from 'immutable';
import { connect } from 'react-redux';

const EditEndpoint = ({
    breadcrumbs,
    dispatchGetEndpoint,
    dispatchClearEndpoint,
    dispatchPutEndpoint,
    match: {
        params: { id: endpointId },
    },
    loading,
    endpoint,
}) => {
    useLayoutEffect(() => {
        dispatchGetEndpoint({ endpointId });

        return () => dispatchClearEndpoint();
    }, []);

    const onSubmit = (formValues) => {
        const newFormValues = { ...formValues };
        newFormValues.permissionType = formValues.permissionType && formValues.permissionType.value;

        dispatchPutEndpoint(endpointId, newFormValues);
    };

    const generateInitialValues = ({
        name,
        description,
        route,
        permissionType
    }) => {
        return {
            name,
            description,
            route,
            permissionType: ENDPOINT_PERMISSION_TYPE[permissionType]
        };
    };

    let content;

    if (loading) content = <Loader />;
    else if (endpoint.isEmpty())
        content = <NoDataResource returnPage={ENDPOINT_PATH} />;
    else
        content = (
            <EndpointForm
                onSubmit={onSubmit}
                initialValues={generateInitialValues(endpoint.toJS())}
            />
        );

    return (
        <Content
            breadcrumbs={breadcrumbs}
            title="Editar Punto de Acceso"
            subtitle="Editar punto de acceso"
            content={content}
        />
    );
};

EditEndpoint.propTypes = {
    breadcrumbs: breadcrumbsPropTypes.isRequired,
    dispatchClearEndpoint: PropTypes.func.isRequired,
    dispatchGetEndpoint: PropTypes.func.isRequired,
    dispatchPutEndpoint: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    match: matchPropTypes.isRequired,
    endpoint: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditEndpoint.defaultProps = {
    loading: false,
};

const mapDispatchToProps = {
    dispatchClearEndpoint: clearEndpoint,
    dispatchGetEndpoint: getEndpoint,
    dispatchPutEndpoint: putEndpoint,
};

const mapStateToProps = (
    { SecurityUnit },
    {
        match: {
            params: { id },
        },
    },
) => ({
    breadcrumbs: [
        ...SecurityUnit.UnitHome.get('breadcrumbs'),
        {
            text: 'Puntos de Acceso',
            href: ENDPOINT_PATH,
        },
        {
            text: 'Ver',
            href: `${ENDPOINT_PATH}/${id}`,
        },
        {
            text: 'Editar',
            href: '',
        },
    ],
    endpoint: SecurityUnit.Endpoint.getIn(['current', 'content']),
    loading: !SecurityUnit.Endpoint.getIn([
        'current',
        'activity',
    ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEndpoint);
